<template>
  <div class="login-container">
    <div class="title">
      <img src="@/assets/icon-green.jpg" alt="">
      <div class="login-title">注册</div>
    </div>
    <div class="submit-form">
      <van-form @submit="onSubmit">
        <van-cell-group inset>
          <van-field
            v-model="username"
            name="手机号"
            label=""
            placeholder="手机号"
            :rules="[{ required: true, message: '请填写手机号' }]"
            left-icon="phone-o"
          >

          </van-field>

          <van-field
            v-model="password"
            type="password"
            name="密码"
            label=""
            placeholder="密码"
            :rules="[{ required: true, message: '请填写密码' }]"
            left-icon="lock"
          />

          <van-field
            v-model="verificationCode"
            center
            label=""
            placeholder="请输入验证码"
            :rules="[{ required: true, message: '请输入验证码' }]"
            left-icon="lock"
          >
            <button
              slot="button" :disabled="!countdown"
              v-bind:class="[countdown ? 'reg_active' : 'reg_disActive']"
              @click="getCode"
            >
              <span v-if="countdown">{{text}}</span>
              <span v-if="!countdown">{{text}} ({{count}})</span>
            </button>
          </van-field>

          <van-checkbox v-model="checked" checked-color="#3398FF" style=" padding: 3.8vw;" :label-disabled="true" shape="square" icon-size="15px">
            <span style="font-size: .5rem;color: #9F9D9D;position: absolute;margin-top: -.5rem">
              我已阅读并同意
              <router-link :to="{path:'/service'}">
              <span style="color: #3398FF">《服务条款》</span>
              </router-link>
              </span>
          </van-checkbox>
        </van-cell-group>
        <div style="margin: 16px;">
          <van-button class="submit-login" block type="primary" native-type="onSubmit">
            注册
          </van-button>
        </div>
      </van-form>
    </div>
    <div class="login-footer">
      <div>
        已有账号?
        <span style="color: rgb(36, 104, 242);" @click="goTo('/login')">登录</span>
      </div>
    </div>
  </div>
</template>
<script>
import {Notify} from "vant";
import CryptoJS from "crypto-js";

export default {
  data() {
    return {
      username: '',
      password: '',
      mob:'1',
      sendMsg:'',
      verificationCode:"",//收到的验证码
      countdown: true,//验证码的状态，默认显示发送验证码
      count: "",//60秒倒计时
      timer: null,
      text:"发送验证码",
      checked:false
    };
  },
  methods: {
    onSubmit(values) {
      if(!this.checked){
        Notify({
          message:'请阅读并同意服务条款',
          type: 'danger',
          duration: 2000
        })
        return false
      }
      let pwd = CryptoJS.MD5(this.password).toString(CryptoJS.enc.Hex).toLowerCase()

      let chid = localStorage.getItem('ch_id')

      // alert(pwd)
      let data = {tel:this.username,afcode:pwd,mob:"1",code:this.verificationCode,fchannel:chid}
      let _this = this
      this.$api.post('login_auth',data,res=>{
        if(res.data.code == 0){
          localStorage.setItem('t',res.data.info.tk)
          localStorage.setItem('userinfo',JSON.stringify(res.data.info.info))
          _this.$notify({ type: 'success', message: '注册/登录成功',duration:2000 })
          setTimeout(()=>{
            _this.$router.push('/show');
          },2000)
        }else{
          _this.$message.error(res.data.msg);
        }
      })
    },
    goTo(path){
      this.$router.push(path);
    },
    getCode() {
        if(!this.username){
          Notify({
            message:'请输入账号',
            type: 'danger',
            duration: 2000
          })
          return false
        }
      var _this = this
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.countdown = false;
        this.text = "重新发送"
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.countdown = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
      if(this.countdown == false){
        _this.$api.post("send_sms",{tel:this.username,mob:1,sq:''},res=>{
           if(res.data && res.data.code == 0){
             this.$message.success('发送成功');
           }else{
             this.$message.error(res.data.msg);
           }
        })
      }
    }
    },
  computed:{

  }
};
</script>
<style scoped>
.van-checkbox__icon{
  height: 12vw;
  margin-left: 3.2vw;
  margin-top: 1.2vw;
}
.login-container{
  height: 100vh;
  background-color: #f6f6f6
}

.login-container .title{
  font-size: 4.8vw;
  text-align: center;
  padding-top: 20vw
}

.login-container .title img {
  width: 26.666667vw;
  height: 26.666667vw;
  border-radius: 2.666667vw
}

.login-container .title .login-title{
  font-size: 6.133333vw;
  font-weight: 800
}

.login-container .submit-form .submit-login{
  background-color: #2468f2;
  border-radius: .666667vw;
  border: none
}
.login-container .login-footer{
  display: flex;
  font-size: 3.733333vw;
  justify-content: space-around
}
.submit-form{
  margin-top: 6.666667vw;
}
.reg_active{
  width: 112px;
  height: 2rem;
  background: #0773e0;
  color: #fff;
  border: none;
}
.reg_disActive{
  width: 112px;
  height: 2rem;
 background: #0773e0;
  color:#fff;
  border: none;
}

</style>



// WEBPACK FOOTER //
// src/view/register.vue